<ng-container *ngIf="(createdToken | async) as token; else form">
  <h4>New user token</h4>
  <p>You will not be able to view this token again once you close this window, so be sure to record it.</p>
  <div class="d-flex align-items-center justify-content-between mb-2">
    <mat-form-field appearance="fill" class="col-11 p-0">
      <input [readonly]="true" [ngModel]="token.ApiToken" matInput>
    </mat-form-field>
    <button mat-icon-button class="copy-button" aria-label="Copy icon" matTooltip="Copy to the clipboard"
      [cdkCopyToClipboard]="token.ApiToken">
        <mat-icon svgIcon="copy"></mat-icon>
    </button>
  </div>
  <hr class="w-100">
  <div class="d-flex justify-content-end">
    <button mat-raised-button type="button" class="btn-grey" [mat-dialog-close]="token">Close</button>
  </div>
</ng-container>

<ng-template #form>
  <form #tokenForm="ngForm" name="form" (ngSubmit)="save()">
    <div mat-dialog-content>
      <div class="form-row align-items-center">
        <div class="col-8 my-1">
          <input class="form-control" placeholder="Token name" name="name" [(ngModel)]="tokenName" required>
        </div>

        <div class="col-4 text-right ml-auto my-1 align-self-end">
          <button mat-raised-button class="w-40 btn-grey"
            [mat-dialog-close]="false">Cancel</button>
          <button mat-raised-button class="ml-2 w-50 btn-green"
            [disabled]="tokenForm.invalid || saveIsInProgress">Create</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
